import React from "react";
import { BaseMessage } from "../types";
import { SynthesizerMessage } from "./synthesizer";
import { ToolMessage } from "./tool";
import { formatDate } from "../utils";

interface UserThreadProps {
  user: BaseMessage;
  synthesizer?: BaseMessage;
  tools: BaseMessage[];
}

export const UserThread: React.FC<UserThreadProps> = ({
  user,
  synthesizer,
  tools,
}) => {
  return (
    <div className="flex flex-col space-y-6">
      {/* User question header */}
      <div className="w-3/5 bg-default-50 p-4 rounded-lg ring-1 ring-default-200 shadow-lg shadow-default flex flex-col space-y-4">
        <div className="flex flex-col space-y-2">
          <div className="text-xs font-medium uppercase text-default-500">
            Vous
          </div>
          <div className="text-default-600 font-medium">{user.content}</div>
        </div>
        <div className="text-[11px] text-slate-400">
          {formatDate(user.created_at)} (#{user.id})
        </div>
      </div>

      {/* Synthesizer response */}
      <div className="flex justify-end">
        <div className="bg-white ring-1 ring-slate-300 w-5/6 rounded-lg text-slate-600 overflow-hidden [&_table]:table-fixed [&_th]:truncate [&_td]:truncate [&_th]:max-w-0 [&_td]:max-w-0">
          {synthesizer && (
            <div className="p-6">
              <SynthesizerMessage message={synthesizer} />
              <div className="text-[11px] text-slate-400 mt-2">
                {formatDate(synthesizer.created_at)} (#{synthesizer.id})
              </div>
            </div>
          )}

          {/* Tool results */}
          {tools.length > 0 && (
            <div>
              {tools.map((tool) => (
                <ToolMessage
                  key={tool.id}
                  message={tool}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
